export enum FuelTankType {
    Unknown = 0,
    Storage = 1,
    Settling = 2,
    Service = 3,
    Overflow = 4,
}
